import React, { useState } from 'react'
import { t } from '@local/translations'

import { useCustomerAuth } from '../auth/CustomerAuthContext'
import { CreditCardRow } from './CreditCardRow'

import styles from './account.module.css'

export const ProfileWallet = (props: { nowDate?: Date }) => {
  return (
    <div
      className={styles.profileWallet}
      data-testid='ProfileWallet'
      role='form'
      tabIndex={0}
    >
      <div className={styles.profileWalletHeading}>{t('profile-wallet.my-wallet')}</div>
      {/*TODO - support toast cash*/}
      {/*<ToastCashBalance nowDate={props.nowDate} />*/}
      <SavedCreditCards />
    </div>
  )
}

const SavedCreditCards = () => {
  const { customer } = useCustomerAuth()
  const [errorMsg, setErrorMsg] = useState('')

  return (
    <div role='list' aria-label={t('profile-wallet.payment-methods')}>
      <div className={'font-semibold'}>{t('profile-wallet.payment-methods-asterisk')}</div>
      {customer?.creditCards?.length ? (
        <div className={'my-2'}>
          {customer?.creditCards.map((card) => (
            <CreditCardRow key={card.guid} {...card} onError={setErrorMsg} />
          ))}
        </div>
      ) : (
        <div className={styles.empty}>
          {t('profile-wallet.check-back-message')}
        </div>
      )}
      {errorMsg && <div className='text-error'>{errorMsg}</div>}
      <div className={'type-caption mb-2 text-secondary'}>
        {t('profile-wallet.card-details-disclaimer')}
      </div>
    </div>
  )
}
